import React, { useEffect } from "react"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import UsersInvestorForm from "./form"
import { useSelector } from "react-redux"

const defaultValues = {
  name: "",
  email: "",
  preference: ["ICD"],
  permissions: [],
  entity_type: "COMPANY",
}

const CreateInvestorUsers = () => {
  const { permissions } = useSelector((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.includes("USERS_CREATE")
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Create User"} breadcrumbItem={"Create User"} />
          <UsersInvestorForm defaultValues={defaultValues} />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateInvestorUsers
